<template>
    <v-row class="pb-offset pt-4">
		<v-col class="pa-0 px-4">
            <v-card elevation="1" class="background-2 round-card">
                <v-tabs
					class="px-2"
                    :height="34"
                    background-color="background-2"
                    slider-color="primary">
                    <v-tab :key="1">Shopify</v-tab>

                    <v-tab-item :key="1">

                        <v-card class="elevation-0 backgroun-2">
                            <v-container class="background-2 pa-0 pt-2" fluid>
                                <v-row>
                                    <v-col cols="12" class="px-6 pt-6">
                                        <h3 class="headline mb-4">Come collegare un negozio Shopify a GiveMeHive</h3>

                                        <div v-for="step in steps" :key="step.number" class="d-flex pb-5">
                                            <v-avatar color="primary" size="32" class="mr-4 mt-1 flex-shrink-0">
                                                <span class="white--text fw500">{{ step.number }}</span>
                                            </v-avatar>
                                            <div class="flex-grow-1">
                                                <div class="subtitle-1 fw500 mb-2" v-html="step.title"></div>
                                                <div class="body-2" v-html="step.body"></div>
                                                <div v-if="step.scopes" class="mt-2">
                                                    <v-chip-group column>
                                                        <v-chip small label v-for="scope in scopes" :key="scope" color="primary" outlined>
                                                            {{ scope }}
                                                        </v-chip>
                                                    </v-chip-group>
                                                    <div class="mt-2 d-flex align-center" style="gap:8px;">
                                                        <v-btn small outlined @click="copyScopes()">
                                                            <v-icon left small>mdi-content-copy</v-icon>
                                                            Copia lista
                                                        </v-btn>
                                                        <span v-if="scopesCopied" class="success--text body-2">Copiati negli appunti</span>
                                                    </div>
                                                </div>
                                                <div v-if="step.urls" class="mt-2">
                                                    <v-simple-table dense class="background-1">
                                                        <template v-slot:default>
                                                            <tbody>
                                                                <tr v-for="(url, k) in step.urls" :key="k">
                                                                    <td class="font-weight-bold pr-3">{{ url.label }}</td>
                                                                    <td><code>{{ url.value }}</code></td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </div>
                                                <div v-if="step.note" class="body-2 mt-2 pa-2" style="background:rgba(255,193,7,0.12);border-left:3px solid #ffc107;">
                                                    <span v-html="step.note"></span>
                                                </div>
                                            </div>
                                        </div>

                                        <v-alert text dense color="warning" icon="mdi-alert-circle-outline" class="mt-4">
                                            <div class="body-2">
                                                Il <strong>Client Secret</strong> dà accesso completo agli scope configurati: trattalo come una password.
                                                Se sospetti una compromissione, rigenera il secret dalla Dev Dashboard e aggiorna il Sito di integrazione in GMH.
                                            </div>
                                        </v-alert>
                                    </v-col>
                                </v-row>

                                <v-divider class="mt-4"></v-divider>
                                <v-row class="pb-3">
                                    <v-col class="d-flex pa-4" cols="12" sm="6">
                                        <v-switch
                                            inset
                                            class="ma-5 pl-3"
                                            v-model="integration.active"
                                            label="Attiva"
                                            color="primary"
                                            :loading="saving"
                                            :disabled="saving || !integration.id"
                                            @change="updateStatus()"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>

                    </v-tab-item>

                </v-tabs>
			</v-card>

		</v-col>
		<v-snackbar
			:timeout= 6000
			color="success"
			v-model="snackbar">
			<span class="fw500">{{ snackbarText }}</span>
			<v-btn dark text @click.native="snackbar = false">Chiudi</v-btn>
		</v-snackbar>
	</v-row>
</template>

<script>

	export default {
        name: 'shopify',
        props: {
            id: Number,
        },
		data() {
			return {
				snackbar: false,
				snackbarText: '',
                integration: {},
                saving: false,
                scopesCopied: false,
                scopes: [
                    'read_products',
                    'write_products',
                    'read_orders',
                    'write_orders',
                    'read_inventory',
                    'write_inventory',
                    'read_fulfillments',
                    'write_fulfillments',
                    'read_merchant_managed_fulfillment_orders',
                    'write_merchant_managed_fulfillment_orders',
                    'read_customers',
                    'write_customers',
                    'read_locations',
                ],
                steps: [
                    {
                        number: 1,
                        title: 'Apri la <strong>Dev Dashboard</strong> dello store Shopify',
                        body: 'Nel pannello admin Shopify vai su <strong>Impostazioni &rarr; App e canali di vendita &rarr; Sviluppa app</strong> e clicca su <strong>Sviluppa app nella Dev Dashboard</strong>. La Dev Dashboard è il nuovo ambiente Shopify per creare e gestire le app personalizzate (sostituisce il vecchio flusso "Custom App legacy" che da gennaio 2026 non è più disponibile per nuove app).',
                    },
                    {
                        number: 2,
                        title: 'Crea una nuova app',
                        body: 'Nella Dev Dashboard clicca <strong>Crea app</strong>, dai un nome (es. <em>GiveMeHive Sync</em>) e conferma. La configurazione dell\'app si fa creando una <strong>nuova versione</strong> (dal menu <em>Versioni</em>): tutti i passaggi successivi vanno fatti dentro al form "Crea versione".',
                    },
                    {
                        number: 3,
                        title: 'Configura le <strong>URLs</strong> dell\'app',
                        body: 'Nella sezione <strong>URL</strong> del form "Crea versione" imposta:',
                        urls: [
                            { label: 'App URL', value: 'https://<dominio-gmh>' },
                            { label: 'URL di reindirizzamento (Allowed redirection URLs)', value: 'https://<dominio-gmh>/api/shopifylogin/callback' },
                        ],
                        note: 'Importante: <strong>NON spuntare</strong> "Incorpora l\'app nel pannello di controllo Shopify" — l\'integrazione GiveMeHive è server-to-server, non un\'app embedded. Lasciare anche "Usa flusso di installazione legacy" deselezionato.',
                    },
                    {
                        number: 4,
                        title: 'Configura gli <strong>Admin API access scopes</strong>',
                        body: 'Nella sezione <strong>Accesso</strong> del form "Crea versione", nel campo <strong>Ambiti</strong> incolla la lista (oppure usa "Seleziona ambiti" e cercali uno per uno):',
                        scopes: true,
                    },
                    {
                        number: 5,
                        title: 'Richiedi accesso ai <strong>Protected Customer Data</strong>',
                        body: 'Gli scope <code>read_customers</code> / <code>read_orders</code> con dati cliente sono "protected": serve un\'autorizzazione separata. Nella stessa sezione <strong>Accesso</strong>, in alto, clicca <strong>Richiedi accesso</strong>. Compila il modulo specificando come use case <em>"Sincronizzazione ordini e anagrafiche cliente verso il gestionale interno GiveMeHive"</em> e seleziona i campi necessari: <strong>nome</strong>, <strong>email</strong>, <strong>phone</strong>, <strong>indirizzi</strong>. Sui dev store l\'approvazione è immediata; sugli store di produzione richiede ~1-3 giorni di review Shopify.',
                    },
                    {
                        number: 6,
                        title: 'Rilascia la versione e installa l\'app',
                        body: 'In alto a destra del form clicca <strong>Rilascia</strong> per attivare la nuova versione. Dopodiché installa l\'app sullo store dalla schermata principale dell\'app nella Dev Dashboard.',
                    },
                    {
                        number: 7,
                        title: 'Recupera <strong>Client ID</strong> e <strong>Client Secret</strong>',
                        body: 'Dal menu <strong>Impostazioni</strong> dell\'app, nella sezione <strong>Credenziali</strong>: trovi <strong>ID client</strong> (Client ID, copialo) e <strong>Segreto</strong> (Client Secret, cliccare l\'occhio per vederlo, poi copialo).',
                    },
                    {
                        number: 8,
                        title: 'Crea il <strong>Sito di integrazione</strong> Shopify in GiveMeHive',
                        body: 'Vai su <strong>Impostazioni &rarr; Integrazioni</strong> e crea (o modifica) un Sito di integrazione selezionando <strong>Shopify</strong> come piattaforma. Compila: <strong>Url</strong> = dominio del negozio (<code>mio-shop.myshopify.com</code>), <strong>Client ID</strong> e <strong>Client Secret</strong> copiati al passo precedente. Configura anche categoria default, condizione di pagamento, cliente generico e codici prodotto per spedizione/commissioni/coupon. Salva.',
                    },
                    {
                        number: 9,
                        title: 'Avvia il <strong>collegamento OAuth</strong>',
                        body: 'Sempre nella pagina del Sito di integrazione, clicca <strong>Collega lo store Shopify</strong>. Verrai reindirizzato su Shopify per autorizzare l\'app: confermando, il token di accesso viene salvato automaticamente in GMH e da quel momento la sincronizzazione di prodotti, ordini e fulfillment è attiva.',
                    },
                ],
			}
		},

		created() {
			this.axios.get('integrationsapps/' + this.id).then(response => {
                this.integration = response.data.data
				this.$store.commit('endProgress')
			}, response => {
			    // error callback
			});
		},

		methods: {

			updateStatus() {
                if (this.saving) return;
                this.saving = true;
                const previous = !this.integration.active;
                this.axios.put('integrationsapps/' + this.id, this.integration).then(response => {
                    this.$store.commit('endProgress')
                    this.integration = response.data.data.model
                    this.snackbarText = this.integration.active ? 'Integrazione Shopify attivata' : 'Integrazione Shopify disattivata'
                    this.snackbar = true
                    this.saving = false
                }, () => {
                    this.integration.active = previous
                    this.saving = false
                })
			},

            copyScopes() {
                const text = this.scopes.join(',')
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(text).then(() => {
                        this.scopesCopied = true
                        setTimeout(() => { this.scopesCopied = false }, 2500)
                    })
                } else {
                    // fallback
                    const ta = document.createElement('textarea')
                    ta.value = text
                    document.body.appendChild(ta)
                    ta.select()
                    document.execCommand('copy')
                    document.body.removeChild(ta)
                    this.scopesCopied = true
                    setTimeout(() => { this.scopesCopied = false }, 2500)
                }
            },
		},
	}
</script>
